










import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterState } from '../stores/modules/filter';
import { cloneDeep } from 'apollo-utilities';
import LoadingVue from '@/components/core/animations/loading-animation.vue';
import { EventBus } from '../event-bus';

const filter = namespace('filter');
const slides = namespace('slides');

@Component({
  components: {
    loading: LoadingVue
  }
})
export default class SlideFilterBoundary extends Vue {
  private showContent: boolean = true;
  private isMounted: boolean = false;

  @filter.State('filter') filter!: FilterState['filter'];
  @filter.State('isLoading') isLoading!: boolean;

  @filter.State('pagination') pagination!: FilterState['pagination'];

  @filter.Action('filterSlides') filterSlides!: () => Promise<void>;
  @filter.Mutation('setCompleteFilter') setCompleteFilter!: (a: FilterState['filter']) => void;
  @filter.Mutation('resetFilter') resetFilter!: () => void;

  mounted() {
    console.log('Mounted Filter');
    this.isMounted = true;
    EventBus.$on('reload-lib', () => {
      console.log('RELOADING LIB');
      this.filterSlides();
    });
    let query = this.$route.query.filter as string | FilterState['filter'];
    if (query) {
      query = JSON.parse(<string>query) as FilterState['filter'];
      this.setCompleteFilter(query);
    } else {
      this.resetFilter();
    }
  }

  @Watch('pagination', { deep: true })
  async onPagination(val: FilterState['pagination']) {
    try {
      await this.filterSlides();
    } catch (error) {
      // TODO: error handling
    }
  }

  @Watch('filter', { deep: true })
  async onFilterChange(val: FilterState['filter'], oldVal: any) {
    const _val: FilterState['filter'] = cloneDeep(val);

    try {
      console.log('Search slides');
      await this.filterSlides();
      try {
        delete _val.active;
        await this.$router.replace({
          query: { ...this.$route.query, filter: JSON.stringify(_val) }
        });
      } catch (error) {
        // Duplicate entry error
      }
    } catch (error) {}
  }
}
